import {
  createAction,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { Middleware, MiddlewareAPI, Dispatch } from "redux";
import Sdk from "api.digitalpages.module.sdk.api";

import { AppDispatch, RootState } from "..";
import { LibrarySections } from "senac-components/dist/pages/Mobile/PageLibrarySection";
import {
  Content,
  ContentFilters,
  ContentOptionAppointments,
  ContentOptionDetail,
  MenuOptions,
  PageHeaderOptionItem,
  PageLibraryHeaderOptionItem,
  PageLibraryOptionAppointments,
  PageLibraryOptionDownloads,
  PageLibraryOptionFavorites,
  PageLibraryOptionReadingList,
  PageOptionContactUs,
  PageOptionFAQ,
  PageOptionHome,
  PageOptionLibrary,
  PageOptionMyProfile,
  PageOptionProfile,
  PageOptionTermsOfUse,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import { ModalButtonOption } from "senac-components/dist/components/Modal";
import { contentSlice, contentSummary, showContentDetail, showContentDetailWithMarks } from "./contentSlice";
import { editTagByUid, FavoritesInternalTag } from "./userDataSlice";
import { UserDataService } from "../../services";
import { TagData } from "../../services/userData/IUserDataService";
import {
  PageLibraryAppointments,
  PageLibraryDownload,
  PageLibraryFavorite,
} from "senac-components";

interface UserModel {
  uid: string;
  name: string;
  login: string;
}

interface Credential {
  login: string;
  password: string;
}

interface CommonState {
  state: "idle" | "initializing" | "initialized";
  alert?: AlertData;
  runningInMobile: boolean;
  withInternet: boolean;
  route?: string;
  referrer?: string[];
  loader?: boolean;
}

interface ModalButtonOptionContent extends ModalButtonOption {
  content?: any;
}

export interface PlayerInfo {
  contentUid: string;
  contentReferenceUid: string;
  summary?: any;
}

export interface AlertData {
  title: string;
  description: string;
  buttons?: ModalButtonOptionContent[];
  show: boolean;
}

const initialState: CommonState = {
  state: "idle",
  runningInMobile: false,
  withInternet: true,
  referrer: ['#/inicio'],
};

export const alertSelectButton = createAction<
  ModalButtonOptionContent | undefined
>("alert/select");

export const filterContent = createAction<ContentFilters>("filter/content");

export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    resetState: () => initialState,

    runningInMobile: (state, data: PayloadAction<boolean>) => {
      state.runningInMobile = data.payload;
      Sdk.Api.request.Request.onMobile = state.runningInMobile;
    },
    withInternet: (state, data: PayloadAction<boolean>) => {
      // console.log("alterando status", data.payload);
      state.withInternet = data.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload
    },
    showAlert: (state, data: PayloadAction<AlertData | undefined>) => {
      state.alert = data.payload;
    },
    changeState: (
      state,
      data: PayloadAction<"idle" | "initializing" | "initialized">
    ) => {
      state.state = data.payload;
    },
    changeRoute: (state, data: PayloadAction<string | undefined>) => {
      if (state.route == data.payload) return;
      state.route = data.payload;
    },
    setRefferer: (state, data: PayloadAction<string | undefined>) => {
      let refs = state.referrer || [];
      if(data.payload === 'reset') refs = [];
      state.referrer = [...refs, window.location.hash];
    },
    recoverPassword: (state) => {
      state.route = "/user/forgot";
    },
    loginOptionsPage: (state) => {
      state.route = "/user/options";
    },
    loginPage: (state) => {
      state.route = "/user/login";
    },
    loginProjectsPage: (state) => {
      state.route = "/user/projects";
    },
    loginPasswordPage: (state) => {
      state.route = "/user/password";
    },
    registerPage: (state) => {
      state.route = "/user/register";
    },
    helpPage: (state) => {
      state.route = "/help";
    },
    changePage: (state) => {
      state.route = "user/change";
    },
    goToPage: (state, option: PayloadAction<MenuOptions>) => {
      console.log(option);
      switch (option.payload) {
        case MenuOptions.Home: {
          state.route = "/inicio";
          break;
        }
        case MenuOptions.Library: {
          state.route = "/library/options";
          break;
        }
        case MenuOptions.Profile: {
          state.route = "/user/profile";
          break;
        }
      }
    },
    goToPageOption: (state, option: PayloadAction<PageHeaderOptionItem>) => {
      const optionSelected = option.payload;

      console.log(optionSelected);

      if (optionSelected == PageOptionHome) {
        state.route = "/inicio";
      } else if (optionSelected == PageOptionLibrary) {
        state.route = "/library/options";
      } else if (optionSelected == PageOptionProfile) {
        state.route = "/user/profile";
      } else if (optionSelected == PageOptionProfile) {
        state.route = "/user/profile";
      } else if (optionSelected == PageOptionProfile) {
        state.route = "/user/profile";
      } else if (optionSelected == PageOptionProfile) {
        state.route = "/user/profile";
      }
    },
    goToMyProfileOption: (
      state,
      option: PayloadAction<PageHeaderOptionItem>
    ) => {
      const optionSelected = option.payload;

      if (optionSelected === PageOptionMyProfile) {
        state.route = "/user/profile";
      } else if (optionSelected === PageOptionTermsOfUse) {
        state.route = "/terms";
      } else if (optionSelected === PageOptionContactUs) {
        state.route = "/contact";
      } else if (optionSelected === PageOptionFAQ) {
        state.route = "/faq";
      }
    },
    goToLibraryPage: (state, option: PayloadAction<LibrarySections>) => {
      switch (option.payload) {
        case LibrarySections.Downloads: {
          state.route = "/library/downloads";
          break;
        }
        case LibrarySections.Favorites: {
          state.route = "/library/favorites";
          break;
        }
        case LibrarySections.Marks: {
          state.route = "/library/appointments";
          break;
        }
        case LibrarySections.ReadingList: {
          state.route = "/library/readinglist";
          break;
        }
      }
    },
    goToLibraryOption: (
      state,
      option: PayloadAction<PageLibraryHeaderOptionItem>
    ) => {
      switch (option.payload) {
        case PageLibraryOptionDownloads: {
          state.route = "/library/downloads";
          break;
        }
        case PageLibraryOptionFavorites: {
          state.route = "/library/favorites";
          break;
        }
        case PageLibraryOptionAppointments: {
          state.route = "/library/appointments";
          break;
        }
        case PageLibraryOptionReadingList: {
          state.route = "/library/readinglist";
          break;
        }
      }
    },
    goToContent: (state, option: PayloadAction<PlayerInfo>) => {      
      if (!state.runningInMobile) {
        state.route = `/content/reference/uid/${option.payload.contentReferenceUid}/player`;
        return;
      }

      var _window: any = window;
      _window.CordovaExec(
        function (status: string) {
          // console.log(status);
        },
        "ShelfPlugin",
        "OpenContentReference",
        [option.payload.contentUid, option.payload.contentReferenceUid, option.payload.summary]
      );
    },
    backPage: () => {
      window.history.back();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(alertSelectButton, (state, action) => {
      if (state.alert) state.alert.show = false;
    });

    // builder.addCase(userLogin.pending, (state, action) => {
    //   state.loading = true;
    // });
  },
});

export const middleware: Middleware =
  (store: MiddlewareAPI<AppDispatch, RootState>) =>
  (next: Dispatch) =>
  async (action: PayloadAction<any>) => {
    const state = store.getState();

    if (
      commonSlice.actions.goToPage.match(action) &&
      state.userState.user == undefined &&
      (action.payload == MenuOptions.Profile ||
        action.payload == MenuOptions.Library)
    ) {
      store.dispatch(commonSlice.actions.loginOptionsPage());
      return;
    }

    if (alertSelectButton.match(action)) {
      var option = action.payload;
      if (option && option.callback) {
        option.callback();
      }
    }

    if (showContentDetail.match(action)) {
      var content = state.contentState.allContents.find(
        (p) => p.uid == action.payload
      );
      if (content)
        store.dispatch(contentSlice.actions.activeReference(content));
        // if (!state.commonState.runningInMobile && window.innerWidth > 1024) {
        //   store.dispatch(contentSummary(content as Content));
        // }
      store.dispatch(contentSlice.actions.goToContentInfo(ContentOptionDetail));
      store.dispatch(
        commonSlice.actions.changeRoute(`/content/uid/${action.payload}`)
      );
    }

    if (contentSlice.actions.goToContentInfo.match(action)) {
      const contentUid = state.contentState.activeContentUid;

      if (contentUid) {
        store.dispatch(
          commonSlice.actions.changeRoute(`/content/uid/${contentUid}`)
        );
        // store.dispatch(contentSlice.actions.goToContentInfo(ContentOptionDetail));
      }
    }

    if (filterContent.match(action)) {
      var filter = action.payload;
      if(filter.category?.uid && filter.category?.uid !== "undefined") {
        store.dispatch(
          commonSlice.actions.changeRoute(
            `/search/category/uid/${filter.category?.uid}`
          )
        );
      } 
      else {
        store.dispatch(
          commonSlice.actions.changeRoute(`/search/metadata?q=${filter.query ? filter.query : ""}`)
        );
      } 
    }

    if (editTagByUid.match(action)) {
      store.dispatch(
        commonSlice.actions.changeRoute(
          `/library/readinglist/uid/${action.payload}`
        )
      );
    }

    if (commonSlice.actions.withInternet.match(action)) {
      var route = action.payload ? "/inicio" : "/offline";
      const unathorized = !state.userState.user && !Sdk.Api.authorization.authenticated;

      store.dispatch(commonSlice.actions.changeRoute(unathorized ? '/inicio' : route));

      if (!action.payload) {
        store.dispatch(
          commonSlice.actions.showAlert({
            show: true,
            title: "Você está off-line",
            description:
              "Conecte-se à internet para conhecer o acervo da Biblioteca Digital Senac.",
          })
        );
      }
    }

    return next(action);
  };

export default commonSlice.reducer;
